import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'root-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements AfterViewInit {
  @Input() accountName: string;
  @Input() isSuperUser: boolean = false;
  @Input() hideMenu: boolean = false;
  @Input() loggedIn: boolean = false;
  @Input() providerType: string;
  @Input() externalUrl: string;
  @Input() role: string;
  @ViewChild('logo') logo!: ElementRef;
  logoOffset: number;
  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}
  ngAfterViewInit() {
    this.updateLogoOffset();
  }
  @HostListener('window:resize')
  OnResize() {
    this.updateLogoOffset();
  }
  navigateHome(): void {
    if (this.externalUrl) {
      window.location.href = this.externalUrl;
      return;
    }
    if (!this.loggedIn) this.router.navigate(['/login']);
    else this.router.navigateByUrl(this.providerType);
  }
  private updateLogoOffset(): void {
    if (this.logo?.nativeElement) {
      this.logoOffset = this.logo.nativeElement.offsetLeft;
      this.cdr.detectChanges();
    }
  }
}
